import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2c-2.56045 0-5.1209.97615-7.07224 2.92744-3.90368 3.90458-3.90368 10.24056 0 14.14516C6.8791 21.0239 9.43955 22 12 22c2.5604 0 5.1199-.9761 7.0722-2.9274 3.9037-3.9046 3.9037-10.24058 0-14.14516C17.1199 2.97615 14.5604 2 12 2zm0 2.0003c2.1384 0 4.1477.83212 5.658 2.34235 1.5103 1.51023 2.3414 3.51953 2.3414 5.65685 0 2.1383-.8311 4.1476-2.3414 5.6578-1.5103 1.5103-3.5196 2.3424-5.658 2.3424-2.13837 0-4.14773-.8321-5.65799-2.3424-3.11955-3.1194-3.11955-8.19518 0-11.31465C7.85227 4.83242 9.86163 4.0003 12 4.0003zM7.46371 15.1218l3.12159-3.1215-3.12159-3.12247 1.41424-1.41421 3.12255 3.12148 3.1215-3.12148 1.4143 1.41421-3.1216 3.12247 3.1216 3.1215-1.4143 1.4142-3.1215-3.1215-3.12255 3.1215-1.41424-1.4142z",
    fill: "currentColor"
  }));
});